<template>
    <v-container
        fluid
        class="pa-0 mx-n2"
    >
        <div class="home-content">
            <div class="d-none d-lg-block">
                <v-row class="mt-8">
                    <v-col cols="3">
                        <v-container
                            fluid
                            class="pa-0"
                        >
                            <v-row>
                                <v-col
                                    class="px-2"
                                    cols="12"
                                >
                                    <useful-card
                                        :svg="cardInfo[0].svg"
                                        :text="cardInfo[0].text"
                                        :route="cardInfo[0].route"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="mt-6">
                                <v-col
                                    class="px-2"
                                    cols="12"
                                >
                                    <useful-card
                                        :svg="cardInfo[2].svg"
                                        :text="cardInfo[2].text"
                                        :route="cardInfo[2].route"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col cols="3">
                        <v-container
                            fluid
                            class="pa-0"
                        >
                            <v-row>
                                <v-col
                                    class="px-2"
                                    cols="12"
                                >
                                    <feedback-form-useful-section />
                                </v-col>
                            </v-row>
                            <v-row class="mt-6">
                                <v-col
                                    class="px-2"
                                    cols="12"
                                >
                                    <useful-card
                                        :svg="cardInfo[3].svg"
                                        :text="cardInfo[3].text"
                                        :route="cardInfo[3].route"
                                        :stroke="true"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col
                        class="px-2"
                        cols="6"
                    >
                        <congratulations-slider />
                    </v-col>
                </v-row>
            </div>
            <div class="d-block d-lg-none">
                <v-row class="mt-8">
                    <v-col
                        class="px-0 px-sm-2"
                        cols="12"
                        sm="6"
                    >
                        <v-container
                            fluid
                            class="pa-0"
                        >
                            <v-row>
                                <v-col cols="12">
                                    <useful-card
                                        :svg="cardInfo[0].svg"
                                        :text="cardInfo[0].text"
                                        :route="cardInfo[0].route"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="mt-6">
                                <v-col cols="12">
                                    <useful-card
                                        :svg="cardInfo[2].svg"
                                        :text="cardInfo[2].text"
                                        :route="cardInfo[2].route"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col
                        class="px-0 px-sm-2"
                        cols="12"
                        sm="6"
                    >
                        <v-container
                            fluid
                            class="pa-0"
                        >
                            <v-row>
                                <v-col cols="12">
                                    <feedback-form-useful-section />
                                </v-col>
                            </v-row>
                            <v-row class="mt-6">
                                <v-col cols="12">
                                    <useful-card
                                        :svg="cardInfo[3].svg"
                                        :text="cardInfo[3].text"
                                        :route="cardInfo[3].route"
                                        :stroke="true"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
                <v-row class="mt-8">
                    <v-col
                        class="px-0 px-sm-2"
                        cols="12"
                    >
                        <congratulations-slider />
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-container>
</template>
<script>
import UsefulCard from '@/components/useful/UsefulCard.vue'
import CongratulationsSlider from '@/components/useful/CongratulationsSlider.vue'
import FeedbackFormUsefulSection from '../forms/FeedbackFormUsefulSection.vue'
export default {
    name: 'UsefulCards',
    components: {
        UsefulCard,
        CongratulationsSlider,
        FeedbackFormUsefulSection
    },
    data() {
        let cardInfo = [
            {
                text: 'Библиотека РАИИ',
                svg: 'M6.832 25.6L6.83636 14.4H8.87273L8.88 25.6H6.832ZM14.976 25.6L14.9818 14.4H17.0182L17.024 25.6H14.976ZM0 32V30H32V32H0ZM23.12 25.6L23.1273 14.4H25.1636L25.168 25.6H23.12ZM0 10V8L16 0L32 8V10H0ZM4.4 8H27.6L16 2L4.4 8Z',
                route: '/library'
            },
            {
                text: 'Корпоративная почта',
                svg: 'M32 3.5C32 1.575 30.56 0 28.8 0H3.2C1.44 0 0 1.575 0 3.5V24.5C0 26.425 1.44 28 3.2 28H28.8C30.56 28 32 26.425 32 24.5V3.5ZM30 2.1875L16 13.5625L2 2.1875H30ZM30 25.8125H2V4.375L16 15.75L30 4.375V25.8125Z',
                route: '#'
            },
            {
                text: 'Медиаресурсы',
                svg: 'M16 30C7.61793 30 2 23.056 2 16C2 8.944 7.2 2 16 2C24.4 2 30 8.944 30 16C30 23.056 23.746 30 16 30ZM16 0C13.8989 0 11.8183 0.413852 9.87706 1.21793C7.93586 2.022 6.17203 3.20055 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C6.17203 28.7994 7.93586 29.978 9.87706 30.7821C11.8183 31.5861 13.8989 32 16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 13.8989 31.5861 11.8183 30.7821 9.87706C29.978 7.93586 28.7994 6.17203 27.3137 4.68629C25.828 3.20055 24.0641 2.022 22.1229 1.21793C20.1817 0.413852 18.1012 0 16 0ZM12.8 23.2L22.4 16L12.8 8.8V23.2Z',
                route: '/resources'
            },
            {
                text: 'Конференции и семинары',
                svg: 'M25.8889 15.2222V18.7778C25.8889 23.6869 21.9092 27.6667 17 27.6667C12.0908 27.6667 8.11111 23.6869 8.11111 18.7778V15.2222M33 17C33 25.8366 25.8366 33 17 33C8.16345 33 1 25.8366 1 17C1 8.16345 8.16345 1 17 1C25.8366 1 33 8.16345 33 17ZM17 22.3333C15.0363 22.3333 13.4444 20.7415 13.4444 18.7778V9.88889C13.4444 7.92521 15.0363 6.33333 17 6.33333C18.9637 6.33333 20.5556 7.92521 20.5556 9.88889V18.7778C20.5556 20.7415 18.9637 22.3333 17 22.3333Z',
                route: '/all_conferences'
            }
        ]
        return {
            cardInfo: cardInfo
        }
    }
}
</script>
